import script from "./GoskluchSignButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoskluchSignButton.vue?vue&type=script&setup=true&lang=ts"

import "./GoskluchSignButton.vue?vue&type=style&index=0&id=4d5b665d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5b665d"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QIcon,QSpinner});
